import { render, staticRenderFns } from "./QcSample.vue?vue&type=template&id=1bab9273"
import script from "./QcSample.vue?vue&type=script&lang=js"
export * from "./QcSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports